import React from "react";
import Checkbox from "../../components/Checkbox";
import { Control, FieldValues, useController, useWatch } from "react-hook-form";
import { FormComponent } from "./FormComponent";
import useFormActions from "../../../subscription/useFormActions";
import { checkboxesChoicesType, reactHookFormValidateType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface CheckboxGroupProps<T extends FieldValues> {
	control: Control<T>;
	checkboxes: checkboxesChoicesType;
	disabled?: boolean;
	fieldKey: string;
	legend?: string;
	onFocus?: () => void;
	required?: boolean;
	validate?: reactHookFormValidateType;
}

export default function CheckboxGroup({
	checkboxes,
	control,
	disabled,
	fieldKey,
	legend,
	onFocus,
	required = false,
	validate,
}: CheckboxGroupProps<any>) {
	const { onUpdateField } = useFormActions();
	const {
		field: { onChange },
		formState: { errors },
	} = useController({
		name: fieldKey,
		control,
		disabled,
		rules: { validate },
		defaultValue: [],
	});

	const currentInput =
		useWatch({
			control,
			name: fieldKey,
		}) || [];

	const component = {
		classes: "checkbox-group",
		id: fieldKey,
		legend,
		name: fieldKey,
		required,
		errors,
	};

	const handleChange = (value: string) => {
		const newInput = [...currentInput];
		const item = value;

		if (newInput.length > 0) {
			const index = newInput.findIndex((x) => x === item);

			if (index === -1) {
				newInput.push(item);
			} else {
				newInput.splice(index, 1);
			}
		} else {
			newInput.push(item);
		}

		onChange(newInput);
		onUpdateField(fieldKey, newInput);
	};

	const checkboxesGroup = checkboxes?.map((item) => {
		const { key, label } = item;

		return (
			<Checkbox
				key={key}
				id={`${fieldKey}_${key}`}
				name={fieldKey}
				checked={currentInput.includes(key)}
				disabled={disabled}
				value={key}
				label={label}
				onFocus={onFocus}
				onToggle={handleChange}
			/>
		);
	});

	return <FormComponent {...component}>{checkboxesGroup}</FormComponent>;
}
